import React from 'react';
import PropTypes from 'prop-types';
import { EmptyState, Flex, Text } from 'onefaceui-react-components';
import { getResourceTo } from 'react/utils/utils';
import { PanelDetails, PanelTable } from '../styles';
import { formatDateTime } from '../../../utils/formatDateTime';

export function StopPanel({ stop }) {
  function getStopInfos() {
    const info = [
      {
        label: getResourceTo('notificationPanel.arrive'),
        planned: formatDateTime(stop?.plannedArrival),
        projected: formatDateTime(stop?.projectedArrival),
        actual: formatDateTime(stop?.actualArrival)
      },
      {
        label: getResourceTo('notificationPanel.depart'),
        planned: formatDateTime(stop?.plannedDeparture),
        projected: formatDateTime(stop?.projectedDeparture),
        actual: formatDateTime(stop?.actualDeparture)
      },
      {
        label: getResourceTo('notificationPanel.service'),
        planned: formatDateTime(stop?.plannedService),
        projected: formatDateTime(stop?.projectedService),
        actual: formatDateTime(stop?.actualService)
      }
    ];

    return info;
  }

  function getPhones() {
    const phones = [];
    if (location?.phone1) {
      phones.push(location.phone1);
    }
    if (location?.phone2) {
      phones.push(location.phone2);
    }

    return phones.join(', ');
  }

  const stopList = getStopInfos();
  const phonesText = getPhones();

  if (!stop) {
    return <EmptyState />;
  }

  return (
    <>
      <PanelDetails>
        <Flex justifyContent="space-between" alignItems="center">
          <Text size="xs">
            {stop.location.key}
            {stop.location.description ? ` - ${stop.location.description}` : ''}
          </Text>
        </Flex>
        {phonesText && <strong>{phonesText}</strong>}
      </PanelDetails>
      <PanelTable>
        <table>
          <thead>
            <tr>
              <th>{getResourceTo('event')}</th>
              <th>{getResourceTo('notificationpanel.planned')}</th>
              <th>{getResourceTo('notificationpanel.projected')}</th>
              <th>{getResourceTo('notificationpanel.actual')}</th>
            </tr>
          </thead>
          <tbody>
            {stopList.map(({ label, planned, projected, actual }) => (
              <tr key={label}>
                <td>{label}</td>
                <td>{planned}</td>
                <td>{projected}</td>
                <td>{actual}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </PanelTable>
    </>
  );
}

StopPanel.propTypes = {
  stop: PropTypes.object
};
